import Vue from 'vue';
import { SButton } from "../../../components/ui-components";
import { SInput } from "../../../components/ui-components";
import appFilter from "../../../components/base/app-filter/app-filter";
import LabelNew from '../../../components/base/vacancies/label-new'
export default Vue.component('uiKit', {
  components: {
    SButton,
    SInput,
    appFilter,
    LabelNew
  },

  data() {
    return {}
  }

});
